

















































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
//import { VueYoutube } from "vue-youtube";
//Vue.use(VueYoutube);

interface Description {
  id: string;
  title: string;
  descriptions: Array<Td>;
}
interface Td {
  id: string;
  title: string;
  images: Array<Image>;
  items: Array<string>;
  pres: Array<Pre>;
}

interface Image {
  src: string;
  comment: string;
}
interface Pre {
  src: string;
  comment: string;
}
interface Description2 {
  id: string;
  title: string;
  descriptions: Array<Td2>;
}
interface Td2 {
  id: string;
  title: string;
  rows: Array<Row>;
  comments: Array<Comment>;
  videos: Array<Video>;
}
interface Row {
  items: Array<string>;
}
interface Comment {
  title: string;
  items: Array<string>;
}
interface Comment3 {
  title: string;
  items: Array<Td3>;
}
interface Td3 {
  id: string;
  td1: string;
  td2: string;
  td3: string;
}
interface Video {
  title: string;
  videoId: string;
}

@Component
export default class HomeComponent extends Vue {
  @Prop()
	private msg!: string;
	private signinStatus = "signed out"
	private isActive = "1"
	private videoId = "0v6MOkamJcE"
	//https://youtu.be/KFni0nda13Q
	created() {
		const user = this.$auth.currentUser
		if (user) {
			// User is signed in.
			const email = user.email
			const uid = user.uid
			this.signinStatus = "signed in"
			//window.console.log("created() 2.User is signed in: ")
			//window.console.log("created() 3.uid: " + uid)
			//window.console.log("created() 4.email: " + email)
		} else {
			// No user is signed in.
			this.signinStatus = "signed out"
			window.console.log("created() 5.No user is signed in: ")
			// 単純な遷移
			//this.$router.push('/signin/')
		}
	}

  play() {
	console.log("play() 1.");
	//var input = context.createMediaStreamSource(stream)
	//console.log("play() 2.");
	//var processor = context.createScriptProcessor(1024, 1, 1);
	//console.log("play() 3.");
	///*
	//const video = document.createElement("video");
	const constraints = {"audio": false, "video": true }
	navigator.mediaDevices.getUserMedia(constraints)
	.then(stream => {
		// カメラ(stream)が使えるよ
		console.log("play() 2.カメラ使えるよ");
		const video = document.querySelector<HTMLVideoElement>('video');
		//const video: HTMLVideoElement = document.createElement("video");
		video!.srcObject = stream
		video!.onloadedmetadata = function(e) {
			console.log("play() 3.動画を演奏する");
			// 動画を演奏する
			video!.play();
		};

	})
	//.then((resolve) => {
	//	video.onloadmetadata = resolve
	//})
	.catch(error => {
		console.log(error)
	})
    //*/
	/*
	navigator.mediaDevices = navigator.mediaDevices || ((navigator.mozGetUserMedia || navigator.webkitGetUserMedia) ? {
	   getUserMedia: function(c) {
	     return new Promise(function(y, n) {
	       (navigator.mozGetUserMedia ||
	        navigator.webkitGetUserMedia).call(navigator, c, y, n);
	     });
	   }
	} : null);

	console.log("play() 2.");
	if (!navigator.mediaDevices) {
	  console.log("play() 3. getUserMedia() not supported.");
	  return;
	}

	// Prefer camera resolution nearest to 1280x720.

	//var constraints = { audio: true, video: { width: 1280, height: 720 } };
	var constraints = { audio: false, video: true };

	// getUserMedia()関数を実行する
	navigator.mediaDevices.getUserMedia(constraints)
	.then(function(stream) {
		// カメラ(stream)が使えるよ
		console.log("play() 4.カメラ使えるよ");
		var video = document.querySelector('video');
		// video selectorにセットする
		video.srcObject = stream
		video.onloadedmetadata = function(e) {
			// 動画を演奏する
			video.play();
		};
	})
	.catch(function(err) {
		// カメラ使えない
		console.log("play() 5.カメラ使えない");
		console.log(err.name + ": " + err.message);
	});
	*/
  }
  
  comments: string[] = [
    '（株）HIRO ICT 研究所が考える空間知能化システムは、空間（住宅）をロボット化するという考え方です。',
    'ロボットとかロボティクスの分野には二つの考え方があります。',
    '一つは、いかにしてロボットをヒューマノイドに近づけるかというものと、もう一つは、空間の方をいかに賢くしていくのかというものです。',
    '人間は人間そっくりなロボットがほしいのでしょうか。今のところ、人間を超えるようなロボットは作れないと言われています。',
    'どんなに頑張っても、鉄腕アトムみたいなロボットは作れない。',
    'だったら空間を賢くしてやることによって、あまり賢くないけど役に立つロボットが空間の中に入ることはできるし、 何よりも人間が空間の中に入ることができる。',
    'そうするとこれまで考えられなかったサービスであるとか、空間のあり方を提供できるのではないかというものです。',
    ];
  features: string[] =  [
     '（株）HIRO ICT 研究所が考える空間知能化システムは、製品名を「トークA愛」と言います。',
     '「トークA愛」は、Googleの「Android」や「Smart Home」技術を利用して、空間（住宅）をロボット化します。',
     '「トークA愛」は、特に、独居高齢者や独居高齢者を見守る人のための機能を提供します。',
     ];

  private contents1: Description = {
  	id: "1",
  	title: "「トークA愛」の応用",
  	descriptions: [
  	 {id: "1",
  	  title: "「トークA愛」のなりたち",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"「トークA愛」は、ダンスの練習ツールとして生まれました。",
  	  	"「トークA愛」は、ダンスの練習を支援することで、ダンスの上達を目指します。",
  	  	"「トークA愛」は、ダンスの練習ツールに必要な音楽や動画の再生機能を持ちます。",
  	  	"「トークA愛」は、聴覚や視覚の他に文字による情報でダンスの練習を支援します。",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "「トークA愛」の利用例",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"「トークA愛」は、「空間知能化」に利用されます。「空間知能化」は、見守りシステムです。",
  	  	"「トークA愛」は、「e-社寺システム」に利用されます。「e-社寺システム」は、お寺による見守りシステムです。",
  	  	"「トークA愛」は、「通販サイト」に利用されます。「通販サイト」は、動画コンテンツなどを販売します。",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "「空間知能化」への適用",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"「空間知能化」は、空間（住宅）をロボット化します。",
  	  	"「空間知能化」は、「Firestore」の「push通信機能」等を活用して、特に独居高齢者や独居高齢者を見守る人のための機能を提供します。",
  	  	"「空間知能化」は、遠隔地に住む高齢者の親をその息子さんや娘さんが見守る機能を提供します。",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "「e-社寺システム」への適用",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"「e-社寺システム」は、和尚さんの講話を檀家の皆様に配信します。",
  	  	"「e-社寺システム」は、昔のようなお寺を中心とするコミュニティを再現します。",
  	  	"「e-社寺システム」は、独居高齢者を見守る機能を提供します。",
  	    ],
	  pres: [],
  	 }, // end of id=4
  	 {id: "5",
  	  title: "「通販サイト」への適用",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"「通販サイト」では、「firestore」を使用して商品と利用者の管理を行います。",
  	  	"「通販サイト」では、「買い物かご」などの機能を使用して商品を購入した利用者から、その代金の回収を行います。",
  	  	"「通販サイト」では、商品を購入した利用者による「レビュー機能」を提供します。",
  	    ],
	  pres: [],
  	 }, // end of id=5
  	 {id: "6",
  	  title: "Firestoreの利用",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"「トークA愛」は、「スマホ・タブレット」「PC（Webブラウザ）」「スマートディスプレイ・スマートスピーカ(Google Nestシリーズ)」など 多くの端末で動作しますが、「Firestore」が提供するデータベースを共通基盤とすることで、情報の一元化を図ります。",
  	  	"例えば、音楽、動画、Youtube動画等のコンテンツ情報（URLなど）は、「Firestore」に格納することで一元化できます。",
  	  ],
	  pres: [],
  	 }, // end of id=6

  	]
  } // end of contents1
  
  private contents2: Description = {
  	id: "2",
  	title: "社交ダンスのための音楽",
  	descriptions: [
  	 {id: "1",
  	  title: "社交ダンスと音楽の関係",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"社交ダンスをより上手に踊りたい場合は、できるだけダンス音楽と親しむ機会を作り、曲に馴染む必要がある。",
  	  	"・ダンスは「音楽にのって」踊るもの",
		"・ダンスと音楽は切っても切れないクルマの両輪",
		"・ダンスにおける音楽の位置は、単なるBGMではない！",
  	  	"社交ダンスにおいては、以下の事が特に重要である。",
  	  	"・男子（とりわけ男子の下半身）は、リズムを担当する。",
		"・女子は、メロディーをしっかり聴いて感じるイメージを全身で表現する。",
		"・メロディーバッキングやオブリガート（助奏、obbligato,obrigado）は、絵画では背景や風景に相当するもので、音楽ではメロディーのイメージをふくらませる。",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "メロディーの構成",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "音楽のリズムとダンスの種目",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"・まずは四拍子の「４ビート」と言うリズムについてですが、ダンスの種目との関係は次のようになります。（↓：曲の例）",
  	  	"・フォックストロット：BPM=28 枯葉　　<audio controls><source src='bgm/autum28.mp3' type='audio/mp3'>",
  	  	"<p><font class='small'>",
  	  	"→お使いのブラウザでは再生できません。<a href='bgm/autum28.mp3'>＜♪こちら＞</a>をお試しください。</font></p></audio>",
  	  	"・クイックSTEP：BPM=48 Hello, Dolly! <audio controls><source src='bgm/HelloDolly.mp3' type='audio/mp3'>",
		"<p><font class='small'>→お使いのブラウザでは再生できません。<a href='bgm/HelloDolly.mp3'>＜♪こちら＞</a>をお試しください。</font></p></audio>",
		"・ジャイブ　　：BPM=41 監獄ロック　　<audio controls><source src='bgm/JailhouseRock.mp3' type='audio/mp3'>",
		"<p><font class='small'>	　→お使いのブラウザでは再生できません。<a href='bgm/JailhouseRock.mp3'>＜♪こちら＞</a>をお試しください。</font></p></audio>",
		"思わずちょっと体を揺らしてリズムを取りたくなりませんか？",
	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "リズム感をよくするには",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=4

  	]
  } // end of contents2

  private contents3: Description = {
  	id: "3",
  	title: "e-社寺システム",
  	descriptions: [
  	 {id: "1",
  	  title: "和尚さんの講話の檀家への配信機能",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "お寺を中心とするコミュニティの再現",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "独居高齢者の見守り機能",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=3

  	]
  } // end of contents3

  private contents4: Description = {
  	id: "4",
  	title: "通販サイト",
  	descriptions: [
  	 {id: "1",
  	  title: "ユーザ管理機能の概要",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "サインアップ",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "会員情報の更新",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "ユーザの退会処理",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"TODO",
  	    ],
	  pres: [],
  	 }, // end of id=4

  	]
  } // end of contents4

  private contents5: Description = {
  	id: "5",
  	title: "スーパーシティ",
  	descriptions: [
  	 {id: "1",
  	  title: "スーパーシティのコンセプト",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"スーパーシティの基本的なコンセプトは以下の通りとなります。",
  	  	"①これまでの自動走行や再生可能エネルギーなど、個別分野限定の実証実験的な取組ではなく、例えば決済の完全キャッシュレス化、行政手続のワンスオンリー化、遠隔教育や遠隔医療、自動走行の域内フル活用など、幅広く生活全般をカバーする取組であること",
  	  	"②一時的な実証実験ではなくて、2030年頃に実現され得る「ありたき未来」の生活の先行実現に向けて、暮らしと社会に実装する取組であること",
  	  	"③さらに、供給者や技術者目線ではなくて、住民の目線でより良い暮らしの実現を図るものであること",
  	  	"という、この３要素を合わせ持ったものであると定義しており、これを「まるごと未来都市」と呼んでいます。",
  	  	"この「まるごと未来都市」の実現を支えるのが、大胆な規制改革です。",
  	  	"遠隔教育、遠隔医療、電子通貨システムなど、ＡＩやビッグデータを効果的に活用した先進的サービスを実現しようとすると、どうしても、各分野の規制改革を、同時一体的に進めなければなりません。",
  	  	"そういう意味では、スーパーシティは、「まるごと規制改革都市」とも言えるかもしれません。TODO",
  	    ],
	  pres: [],
  	 }, // end of id=1
  	 {id: "2",
  	  title: "データ連携基盤",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"スーパーシティでは、データ連携基盤整備事業が事業の核になります。",
  	  	"複数のサービスのデータ連携を条件としているので、このデータ連携基盤の有無がスーパーシティであるかどうかの一つの目安・区分になります。",
  	  	"誰が担い手となるかですが、多くの場合、個別のサービス（ピンクの部分）は民間事業者が、データ連携基盤整備事業（ブルーの部分）は自治体が事業主体となり、民間事業者が受託事業者として整備する形になろうかと思います。",
  	  	"しかし、全ての事業を民間が担っても、公的団体が担っても、それで住民の皆さんが賛同していただけるのであれば、主体要件は特段制約はありません。",
  	  	"また、「データ連携基盤」というと、たいそうなシステムを連想されるかもしれませんが、実態は、そうとも限りません。例えば、タクシーの配車予約と病院の通院予約を連携させるといったように、複数のサービスの間をつなぐだけで、特定の事業者が大きなデータを持たないようなデータ連携基盤もあります。ベンチャー企業だけでも十分作れる場合もあります。",
  	  	"したがって、技術的スペックは心配せず、まずは、解決したい社会的課題からアプローチしていただければ、その実現方法は、いくらでもご相談にのります。",
  	  	"データ連携の際に大切となるのが、API（アプリケーション・プログラミング・インターフェース）です。",
  	  	"例えば、複数のシステム（例えば、タクシーの配車予約と病院の通院予約など）を、必ずしも強引に一つのシステムに統合する必要はありません。",
  	  	"お互いがデータやプログラム上の指示をやり取りするときのルールさえ決めておけば、それぞれのシステムを大きくいじらずに、連携することができます。そのときのデータや指示をやり取りするときのルールを、APIといいます。",
  	  	"それぞれのシステムは、自分のAPIさえ公開しておけば、繋がりたいシステムの側で、データやプログラム上の指示の送り方を公開されたAPIに合わせれば、必ず連携することができます。",
  	  	"連携のスピードや効率の問題がありますから、ただAPIが互いに公開されていれば良いというだけでもありませんが、基本は、このAPIが開示されていることが、スーパーシティに参加する最低条件となります。",
  	  ],
	  pres: [],
  	 }, // end of id=2
  	 {id: "3",
  	  title: "事例：高齢者の通院対策に悩むＡ市の例",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"データ連携の例について、Ａ市の事例をご紹介させていただきます。これは、実際に要望のあった街の事例です。",
  	  	"人口が６万人程度。免許を返納する後期高齢者が急増している街で、アンケートを取ると、これらの高齢者が１日に使える現金が千円から二千円とのこと。これでタクシーを利用することになると、病院に行くことはできても帰ってこれません。また、タクシー事業の方も３社合計で10数台まで車両保有台数が減少し、ドライバーも高齢化。そもそも十分なタクシーサービスの供給が危ぶまれます。",
  	  	".",
  	  	"そこで、タクシー事業者３社自らが、市民の車を活用したボランティアタクシー事業を提案されました。",
  	  	"利用料金の支払いも、協力してくれたドライバーへの支払いもボランティアポイント。市役所からの各種助成も、ボランティアポイントを利用して行い、ポイント制度自体を広く普及させつつ、更には、病院の通院予約との連動による配車の最適化や、遠隔診療の対象拡大による、通院需要自体のオンラインへの置き換えを進めていくことで、後期高齢者の通院問題を解決しようというご提案です。",
  	  	".",
  	  	"その実現には、技術的には、配車システムと通院システムや遠隔診療システムとの連携。各種支払いサービスへのボランティアポイントシステムの連動が必要となります。",
  	  	"また、規制改革的には、ボランティアタクシー事業の自家用有償事業としての適切性の確認、若しくは必要であれば規制緩和、遠隔診療の対象の拡大、ボランティアポイント制度自身の金融関連諸制度の整理などが必要となってきます。",
  	  	"この提案自体は、高齢者の通院問題の解決という比較的絞られた生活上の課題に対して、設計されたスーパーシティ事業のご提案ですが、これがさらに大きな社会的課題の設定に応えるものになればなるほど、様々なサービスが、より大規模に連携・稼働していくことになろうかと思います。",
  	    ],
	  pres: [],
  	 }, // end of id=3
  	 {id: "4",
  	  title: "「トークA愛」のスーパーシティへの適用",
  	  images: [
  	    { src: "",
  	  	  comment: "",
  	    },
  	  ],
  	  items: [
  	  	"①構成事業者一覧",
  	  	"②構成事業者会社概要（事業者ごと）",
  	  	"③業務実施体制",
  	  	"④企画提案",
  	  	"・スーパーシティの全体像",
  	  	"・全体のスケジュール感",
  	  	"・産官学連携の考え方",
  	  	"・住民合意の考え方・進め方",
  	  	"・国への応募書類作成にあたっての本市との役割分担の考え方",
  	  	"⑤企画提案 分野別事業概要説明および補足説明",
  	  	"・当該分野の事業に関わる事業者名",
  	  	"・解決したい地域課題",
  	  	"・事業内容",
  	  	"・規制改革の内容",
  	  	"・実現に向けたプロセス（スケジュール感）",
  	  	"・市民にとってのメリット・デメリット及び課題",
  	  	"・デジタルデバイドへの配慮",
  	  	"・実現に要する概算費用",
  	  	"・地元企業・事業者との連携",
  	  	"⑥企画提案 データ連携基盤整備概要説明および補足説明",
  	  	"・データ連携基盤整備の考え方（他地域への発展性も含む）",
  	  	"・「オプトイン型」・個人情報保護・データの分散管理の考え方",
  	  	"⑦その他",
  	  	"通常、「API」とは、Webサーバの一種であるRESTサーバが提供するサービスの事を指すことが多い。",
  	  	"内閣府の「API」と言うコンセプトがRESTサーバのサービスであるとしたら、現状では時代遅れである。",
  	  	"「トークA愛」が提供する「API」は、情報そのものアクセスするサービスを指すことにする。",
  	    ],
	  pres: [],
  	 }, // end of id=4

  	]
  } // end of contents5
}
